import { useState } from "react";
import { ChevronDown } from "lucide-react";
import { cn } from "@/lib/utils";
import { Kbd } from "@/components/shared/ListNav";
import { PropPicker, OptionList } from "@/components/tasks/TaskProps";

// 371 (varianta B): vlastnost dokladu jako řádek „popisek – hodnota“ (Linear); hodnota je výběr bez rámečku.
export const PROP_TRIGGER = "h-9 w-auto max-w-full -ml-2 px-2 gap-2 border-0 bg-transparent shadow-none hover:bg-secondary/70 focus:ring-0 font-semibold justify-start text-left";

export function PropRow({ label, kbd, children }) {
  return (
    <div className="grid grid-cols-[104px_minmax(0,1fr)] md:grid-cols-[132px_minmax(0,1fr)] items-center gap-2 min-h-[40px]">
      <span className="text-sm text-muted-foreground">{label}</span>
      <div className="min-w-0 flex items-center gap-2">{children}{kbd && <Kbd className="ml-auto">{kbd}</Kbd>}</div>
    </div>
  );
}

// Klávesa (Z) otevře výběr ve vlastnostech — ne při psaní, v rozbalené nabídce ani s modifikátorem.
export function propHotkey(key, onHit) {
  return (e) => {
    if (e.key.toLowerCase() !== key) return;
    if (e.metaKey || e.ctrlKey || e.altKey || e.defaultPrevented) return;
    if (e.target?.closest?.("input, textarea, select, [contenteditable='true'], [role='listbox'], [role='menu']")) return;
    e.preventDefault(); onHit();
  };
}

// 376: výběr ve vlastnostech dokladu jako v detailu úkolu — bublina (na telefonu okno zespodu), ↑ ↓ Enter, Esc;
// search = pole Hledat (zakázek bývají stovky), bez něj čísla 1–9. options = [{ value, label, sub?, on?, key? }].
// Bez open/onOpenChange si stav drží sám (výběr u položky, hromadné nastavení); triggerClass = vzhled pole formuláře.
export const SELECT_LOOK = "flex h-9 w-full items-center justify-between gap-2 whitespace-nowrap rounded-md border border-input bg-card px-3 py-2 text-sm shadow-sm text-left focus:outline-none focus:ring-2 focus:ring-ring focus:border-ring";
export function PropSelect({ open: openProp, onOpenChange: setOpenProp, mobile, title, icon: Icon, valueLabel, options, onPick, search, placeholder,
  testid, triggerTestid, triggerClass, triggerTitle, children, width = 320 }) {
  const [own, setOwn] = useState(false);
  const open = openProp ?? own, onOpenChange = setOpenProp ?? setOwn;
  const trigger = (
    <button type="button" data-testid={triggerTestid} aria-label={title} title={triggerTitle} onClick={mobile ? () => onOpenChange(true) : undefined}
      className={triggerClass ? cn(SELECT_LOOK, triggerClass)
        : `${PROP_TRIGGER} inline-flex items-center rounded-md text-sm whitespace-nowrap outline-none focus-visible:ring-2 focus-visible:ring-ring data-[state=open]:bg-secondary/70`}>
      {children || <>{Icon && <Icon size={16} className="text-muted-foreground shrink-0" />}<span className="truncate">{valueLabel}</span></>}
      <ChevronDown size={16} className="opacity-50 shrink-0" />
    </button>
  );
  return (
    <PropPicker open={open} onOpenChange={onOpenChange} trigger={trigger} title={title} mobile={mobile} width={width} testid={`${testid}-pop`}>
      <OptionList testid={testid} mobile={mobile} search={search} placeholder={placeholder} options={options}
        onPick={(o) => { onOpenChange(false); if (!o.on) onPick(o.value); }} />
    </PropPicker>
  );
}
